var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { id: _vm.modalId, "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _c("i", { staticClass: "far fa-clock" }),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("kanbanTimeTracking")))])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#" + _vm.modalId
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("kanbanDurationHM")) +
                      "\n                        "
                  ),
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.hours,
                          expression: "hours",
                          modifiers: { number: true }
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "text-align": "right", flex: "0 0 5rem" },
                      attrs: { type: "number" },
                      domProps: { value: _vm.hours },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.hours = _vm._n($event.target.value)
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.minutes,
                          expression: "minutes",
                          modifiers: { number: true }
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "text-align": "right", flex: "0 0 4rem" },
                      attrs: { type: "number", min: "-59", max: "59" },
                      domProps: { value: _vm.minutes },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.minutes = _vm._n($event.target.value)
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("kanbanBookOnUser")) +
                        "\n                        "
                    ),
                    _c("v-select", {
                      attrs: {
                        options: _vm.users,
                        label: "name",
                        reduce: user => user.id,
                        clearable: false
                      },
                      model: {
                        value: _vm.userId,
                        callback: function($$v) {
                          _vm.userId = $$v
                        },
                        expression: "userId"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("kanbanComment")) +
                  "\n                "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.comment,
                    expression: "comment",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.comment },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.comment = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    "data-toggle": "modal",
                    "data-target": "#" + _vm.modalId
                  },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("btnSave")) +
                      "\n                "
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }